import { render, staticRenderFns } from "./OnboardingCardForm.vue?vue&type=template&id=0739f7a3&scoped=true"
import script from "./OnboardingCardForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingCardForm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OnboardingCardForm.vue?vue&type=style&index=0&id=0739f7a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0739f7a3",
  null
  
)

export default component.exports